import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checkBoxContainer: {
    display: 'flex',
    alignItems: 'center',

    '& .label': {
      margin: 0,
      marginLeft: 10,
      fontWeight: '400',
      fontSize: 14,
    }
  },
  btnUpload: {
    borderRadius: 20,
    background: '#02b2e6',
    color: '#fff!important',
    border: 'none',
    fontSize: 11,
    paddingLeft: 10,
    paddingright: 10,
    cursor: 'pointer',
    outline: 'none',
  },
  btnClear: {
    marginLeft: '10px',
    borderRadius: 20,
    background: '#e6e6e6',
    color: 'rgb(0, 0, 0)!important',
    border: 'none',
    fontSize: 11,
    paddingLeft: 10,
    paddingright: 10,
    cursor: 'pointer',
    outline: 'none',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  }
}));

function ImageUpload(props) {
  const {
    isEdit,
    title,
    url,
    checkUpdateBackground,
    checkResize,
    fileName,
    onFileSelect,
    onChangeCheckBox,
    onUpload,
    onClear
  } = props;

  const classes = useStyles();

  const handleFileSelect = (e) => {
    if (onFileSelect) {
      onFileSelect(title, e.target.files[0]);
    }
  };

  const handleChangeCheckBox = (e) => {
    if (e.target.name === 'backgroundCheckBox') {
      onChangeCheckBox({placement: title, updateBackground: e.target.checked});
    } else {
      onChangeCheckBox({placement: title, resize: e.target.checked});
    }
  }

  const fileDrop = e => {
    e.preventDefault();

    const files = e.dataTransfer.files;
    if (files.length) {
      onFileSelect(title, files[0]);
    }
  };

  return (
    <>
      <h6>{title}</h6>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <img src={url} alt={title} />
        </Grid>
        <Grid item xs={8}>
          {isEdit && (
            <div
              id={`${title}-drop-container`}
              className="drop-container"
              onDrop={fileDrop}
            >
              {!!fileName && <p>{fileName}</p>}
              <input
                accept="image/*"
                className="file-input"
                type="file"
                onChange={handleFileSelect}
              />
            </div>
          )}
          <textarea
            className="form-control"
            name="image1"
            value={url}
          />
          <div className={classes.footer}>
            <div>
              <div className={classes.checkBoxContainer}>
                <input
                  type="checkbox"
                  name="backgroundCheckBox"
                  id={`${title}-check-box`}
                  checked={checkUpdateBackground}
                  onChange={handleChangeCheckBox}
                />
                <p className="label">Update background</p>
              </div>
              <div className={classes.checkBoxContainer}>
                <input
                  type="checkbox"
                  name="sizeCheckBox"
                  id={`${title}-check-box`}
                  checked={checkResize}
                  onChange={handleChangeCheckBox}
                />
                <p className="label">Resize</p>
              </div>
            </div>

            <div>
              <button type="button" className={classes.btnUpload} onClick={onUpload}>
                <i class="fa fa-upload" /> Upload
              </button>
              <button
                type="button"
                className={classes.btnClear}
                onClick={onClear}
              >
                <i className="fa fa-times-circle" /> Clear
              </button>
            </div>
          </div>

        </Grid>
      </Grid>
    </>
  );
}

export default ImageUpload;
